import { NgModule } from '@angular/core';
import { DefaultLayoutComponent } from './default-layout.component';
import { RouterOutlet } from '@angular/router';

@NgModule({
  imports: [RouterOutlet],
  declarations: [DefaultLayoutComponent],
  exports: [DefaultLayoutComponent]
})
export class DefaultModule {}
